import { ElementType } from 'react';
import {
  BadgeMinusIcon,
  BookXIcon,
  SparklesIcon,
  StarIcon,
  ThumbsDownIcon,
  TrophyIcon,
  UserSquare2Icon,
} from 'lucide-react';

import { TBidRankStatus, TBidTag } from '@northladder/services';

interface IRankBadgeOptions {
  className: string;
  Icon: ElementType;
}

/**
 * -----------------------------------------------------------------------------
 * Returns a Lucide icon component based on the bid rank status.
 * - NOTE: In the future we might replace the Lucide icons with custom SVGs icons
 * required\
 *
 * @deprecated - Use getRankBadgeOptionsFromTag instead.
 */
export function getRankBadgeOptions(rank: TBidRankStatus): IRankBadgeOptions {
  switch (rank) {
    case 'rank-one':
      return {
        className: `
          text-action-label bg-linear-to-r from-primary-500/20
          to-primary-950/20 border-primary-500/40 dark:border-primary-300/20`,
        Icon: TrophyIcon,
      };
    case 'winning':
      return {
        className:
          'bg-rank-winning-bg text-rank-winning-text border-rank-winning-border',
        Icon: StarIcon,
      };
    case 'out-of-summit':
      return {
        className: 'bg-rank-bg ',
        Icon: ThumbsDownIcon,
      };
    case 'not-winning':
      return {
        className: 'bg-rank-bg text-rank-bg-text border-rank-bg-border',
        Icon: ThumbsDownIcon,
      };
    case 'out-of-qty':
      return {
        className: 'bg-rank-hot-bg border-rank-hot-border text-rank-hot-text',
        Icon: BadgeMinusIcon,
      };
    case 'my-bids':
      return {
        className: '',
        Icon: UserSquare2Icon,
      };
    case 'no-bids':
    default:
      return {
        className: '',
        Icon: BookXIcon,
      };
  }
}


interface IRankBadgeOptionsFromTag {
  className: string;
  color?: string;
  Icon: ElementType;
}

/**
 * -----------------------------------------------------------------------------
 * Returns a Lucide icon component based on the bid rank status.
 * - NOTE: In the future we might replace the Lucide icons with custom SVGs icons
 * required
 */
export function getRankBadgeOptionsFromTag(rank: TBidTag): IRankBadgeOptionsFromTag {
  switch (rank) {
    case 'rank-one':
      return {
        className: `
          text-action-label bg-linear-to-r from-primary-500/20
          to-primary-950/20 border-primary-500/40 dark:border-primary-300/20`,
        Icon: TrophyIcon,
      };
    case 'winning':
      return {
        className:
          'bg-rank-winning-bg text-rank-winning-text border-rank-winning-border',
        Icon: StarIcon,
      };
    case 'runner-up':
      return {
        className:
          'bg-rank-winning-bg text-rank-winning-text border-rank-winning-border',
        Icon: SparklesIcon,
      };
    case 'not-winning':
      return {
        className: 'bg-rank-bg text-orange-500 border-rank-bg-border',
        Icon: ThumbsDownIcon,
      };
    case 'out-of-qty':
      return {
        className: 'bg-rank-hot-bg border-rank-hot-border text-rank-hot-text',
        Icon: BadgeMinusIcon,
      };
    case 'in-queue':
    case 'my-bids':
      return {
        className: 'bg-rank-bg text-green-300 border-rank-bg-border',
        Icon: UserSquare2Icon,
      };
    case 'no-bids':
    default:
      return {
        className: '',
        Icon: BookXIcon,
      };
  }
}
